import React, { useRef } from 'react';
import * as S from './styles';
// import Events from '../../Events';
function Home1() {
  const divRef = useRef<HTMLDivElement | null>(null); // Especificando que o ref pode ser de um HTMLDivElement ou null

  const scrollToDiv = () => {
    divRef.current && divRef.current.scrollIntoView({ behavior: 'smooth' }); // Scroll suave até a div
  };
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <div>
            <h3>Formação em Psicanálise</h3>
          </div>
          <p>
            Tradição e contemporaneidade para formar clínicos e pesquisadores
            críticos, com escuta sensível e estilo próprio.
          </p>
          {/* <button onClick={scrollToDiv}>Ver mais</button>{' '} */}
        </S.TextDiv>
      </S.Section>
      <div ref={divRef} />
    </S.Main>
  );
}

export default Home1;
